import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { DownLoadFileService } from 'studio-components/shared/services/download-file.service';
import { Theme } from 'studio-components/shared/types/theme.type';

@Component({
  selector: 'studio-copiable-text',
  templateUrl: './copiable-text.component.html',
  styleUrls: ['./copiable-text.component.scss'],
})
export class CopiableTextComponent {
  @HostBinding('class')
  @Input()
  theme: Theme = 'light';
  @HostBinding('class.icon-overlay') get isCopyIconOverlaid() {
    return !this.canDownload && !this.isCode;
  }
  @Input() label: string | null;
  @Input() text: string;
  @Input() canDownload = false;
  @Input() isCode = false;
  @Input() filename = 'file';
  @Output() public copied = new EventEmitter<string>();

  constructor(private downloadFileService: DownLoadFileService) {}

  codeFormatText(text: string) {
    return text.replace(new RegExp('&', 'g'), '&amp;').replace(new RegExp('<', 'g'), '&lt;');
  }

  downloadTextAsFile(text: string, mimeType = 'text/plain') {
    const blob = new Blob([text], { type: mimeType });
    this.downloadFileService.blobToFile(blob, mimeType, this.filename);
  }
}
